(function () {
  'use strict';

  if (window.__SHTemplateQuickAddParityV102) return;
  window.__SHTemplateQuickAddParityV102 = true;

  var ROOT_CONFIGS = [
    { root: '[data-sh-lighting-editorial]', card: '.sh-lec__card[data-handle]', data: '[data-sh-product-data]', trigger: 'button[data-sh-quick]' },
    { root: '[data-sh-trending-editorial]', card: '.sh-te__card[data-handle]', data: '[data-sh-product-data]', trigger: 'button[data-sh-quick]' },
    { root: '[data-sh-home-accessories]', card: '.sh-ha__card[data-handle]', data: '[data-sh-product-data]', trigger: 'button[data-sh-quick]' },
    { root: '[data-sh-textile-architecture]', card: '.sh-tx__card[data-handle]', data: '[data-sh-product-data]', trigger: 'button[data-sh-quick]' },
    { root: '[data-sh-art-poster-index]', card: '.sh-pi__card[data-handle]', data: '[data-sh-product-data]', trigger: 'button[data-sh-quick]' },
    { root: '[data-sh-furniture-room-anchors]', card: '.sh-furn__card[data-handle]', data: '[data-sh-furniture-products]', trigger: 'button[data-quick-add]' }
  ];

  var productCache = new WeakMap();
  var active = null;
  var lastFocus = null;
  var selectedOptions = [];
  var backdrop = null;
  var drawer = null;

  function findConfig(trigger) {
    for (var i = 0; i < ROOT_CONFIGS.length; i += 1) {
      var config = ROOT_CONFIGS[i];
      var root = trigger.closest(config.root);
      if (!root || !trigger.matches(config.trigger)) continue;
      var card = trigger.closest(config.card);
      if (!card) continue;
      return { config: config, root: root, card: card };
    }
    return null;
  }

  function readProducts(root, selector) {
    var cached = productCache.get(root);
    if (cached) return cached;
    var node = root.querySelector(selector);
    if (!node) return [];
    var products = [];
    try {
      products = JSON.parse(node.textContent || '[]');
    } catch (error) {
      console.error('SickHaus template quick-add product data could not be read.', error);
    }
    if (!Array.isArray(products)) products = [];
    productCache.set(root, products);
    return products;
  }

  function optionName(raw, variant, index) {
    var entry = variant && Array.isArray(variant.options) ? variant.options[index] : null;
    if (entry && typeof entry === 'object' && entry.name) return String(entry.name);
    var source = raw && Array.isArray(raw.options) ? raw.options[index] : null;
    if (source && typeof source === 'object' && source.name) return String(source.name);
    if (typeof source === 'string') return source;
    return 'Option ' + (index + 1);
  }

  function optionValue(entry) {
    if (entry && typeof entry === 'object') {
      if (entry.value != null) return String(entry.value);
      if (entry.name != null && entry.value == null) return String(entry.name);
    }
    return entry == null ? '' : String(entry);
  }

  function normalizeProduct(raw) {
    if (!raw) return null;
    var sourceVariants = Array.isArray(raw.variants) ? raw.variants : [];
    var variants = sourceVariants.map(function (variant) {
      var entries = Array.isArray(variant.options) ? variant.options : [];
      var values = entries.map(optionValue);
      return {
        id: String(variant.id || ''),
        available: variant.available !== false,
        title: variant.title || '',
        priceFormatted: variant.priceFormatted || raw.priceFormatted || '',
        compareAtFormatted: variant.compareAtFormatted || '',
        price: Number(variant.price || 0),
        compareAt: Number(variant.compareAt || 0),
        image: variant.image || raw.image || '',
        options: values
      };
    });

    var optionCount = variants.reduce(function (max, variant) {
      return Math.max(max, variant.options.length);
    }, 0);
    var options = [];
    for (var index = 0; index < optionCount; index += 1) {
      var name = optionName(raw, sourceVariants[0], index);
      var values = [];
      variants.forEach(function (variant) {
        var value = variant.options[index];
        if (!value || String(value).toLowerCase() === 'default title') return;
        if (values.indexOf(value) === -1) values.push(value);
      });
      if (values.length) options.push({ name: name, index: index, values: values });
    }

    return {
      handle: raw.handle || '',
      title: raw.title || '',
      url: raw.url || ('/products/' + (raw.handle || '')),
      image: raw.image || '',
      imageAlt: raw.imageAlt || raw.title || '',
      currency: raw.currency || 'GBP',
      display: raw.display && typeof raw.display === 'object' ? raw.display : null,
      variants: variants,
      options: options
    };
  }

  function getProduct(context) {
    var handle = context.card.dataset.handle || context.card.dataset.productHandle || context.triggerValue || '';
    var products = readProducts(context.root, context.config.data);
    var raw = products.find(function (product) { return product && String(product.handle) === String(handle); });
    return normalizeProduct(raw);
  }

  function createDrawer() {
    if (drawer && backdrop) return;

    backdrop = document.createElement('div');
    backdrop.className = 'sh-uc-drawer__backdrop';
    backdrop.setAttribute('aria-hidden', 'true');

    drawer = document.createElement('aside');
    drawer.className = 'sh-uc-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-label', 'Choose product options');
    drawer.innerHTML = [
      '<div class="sh-uc-drawer__head">',
        '<div><small data-sh-template-qa-eyebrow>Quick add</small><strong data-sh-template-qa-heading>Choose your options</strong></div>',
        '<button class="sh-uc-drawer__close" type="button" data-sh-template-qa-close aria-label="Close">×</button>',
      '</div>',
      '<div class="sh-uc-drawer__scroll">',
        '<div class="sh-uc-drawer__media"><img data-sh-template-qa-image alt=""></div>',
        '<div class="sh-uc-drawer__body">',
          '<p class="sh-uc-drawer__kicker">Available options</p>',
          '<h2 data-sh-template-qa-title></h2>',
          '<div class="sh-uc-drawer__price" data-sh-template-qa-price></div>',
          '<div class="sh-uc-drawer__selection"><span>Selected</span><strong data-sh-template-qa-selection></strong></div>',
          '<div class="sh-uc-drawer__options" data-sh-template-qa-options></div>',
          '<p class="sh-uc-drawer__status" data-sh-template-qa-status aria-live="polite"></p>',
        '</div>',
      '</div>',
      '<div class="sh-uc-drawer__foot">',
        '<button class="sh-uc-drawer__primary" type="button" data-sh-template-qa-add>Add to bag</button>',
        '<a class="sh-uc-drawer__link" data-sh-template-qa-view href="#">View product</a>',
      '</div>'
    ].join('');

    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
    backdrop.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', onDrawerClick);
  }

  function seedSelection(product) {
    var initial = product.variants.find(function (variant) { return variant.available; }) || product.variants[0] || null;
    selectedOptions = initial ? initial.options.slice() : [];
  }

  function findVariant(product) {
    if (!product) return null;
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === selectedOptions[index];
      });
    }) || null;
  }

  function optionValueAvailable(product, optionIndex, value) {
    return product.variants.some(function (variant) {
      if (!variant.available || variant.options[optionIndex] !== value) return false;
      return variant.options.every(function (variantValue, index) {
        return index === optionIndex || !selectedOptions[index] || variantValue === selectedOptions[index];
      });
    });
  }

  function priceMarkup(variant) {
    if (!variant) return '';
    var compare = variant.compareAt > variant.price && variant.compareAtFormatted
      ? '<s>' + escapeHtml(variant.compareAtFormatted) + '</s>'
      : '';
    return compare + '<span>' + escapeHtml(variant.priceFormatted || '') + '</span>';
  }

  function renderDrawer() {
    if (!active || !drawer) return;
    var product = active.product;
    var variant = findVariant(product) || product.variants.find(function (item) { return item.available; }) || product.variants[0] || null;

    setText('[data-sh-template-qa-title]', product.title);
    var image = drawer.querySelector('[data-sh-template-qa-image]');
    if (image) {
      image.src = variant && variant.image ? variant.image : product.image;
      image.alt = product.imageAlt || product.title;
    }
    var price = drawer.querySelector('[data-sh-template-qa-price]');
    if (price) price.innerHTML = priceMarkup(variant);
    var adaptive = adaptiveQuickAdd();
    setText('[data-sh-template-qa-selection]', adaptive ? adaptive.selectionCopy(product, selectedOptions) : selectedOptions.filter(Boolean).join(' · '));

    var options = drawer.querySelector('[data-sh-template-qa-options]');
    if (options) {
      options.innerHTML = adaptive ? adaptive.renderOptions(product, selectedOptions) : product.options.map(function (option) {
        var buttons = option.values.map(function (value) {
          var isActive = selectedOptions[option.index] === value;
          var available = optionValueAvailable(product, option.index, value);
          return '<button class="sh-uc-drawer__option' + (isActive ? ' is-active' : '') + '" type="button" data-sh-template-qa-option="' + option.index + '" data-value="' + escapeAttr(value) + '"' + (available ? '' : ' disabled') + ' aria-pressed="' + (isActive ? 'true' : 'false') + '">' + escapeHtml(value) + '</button>';
        }).join('');
        return '<fieldset class="sh-uc-drawer__option-group"><legend>' + escapeHtml(option.name) + '</legend><div class="sh-uc-drawer__option-values">' + buttons + '</div></fieldset>';
      }).join('');
    }

    var add = drawer.querySelector('[data-sh-template-qa-add]');
    var status = drawer.querySelector('[data-sh-template-qa-status]');
    var available = !!(variant && variant.available);
    if (add) {
      add.disabled = !available;
      add.textContent = available ? 'Add to bag' : 'Currently unavailable';
    }
    if (status) status.textContent = available ? 'Ready when you are.' : 'This combination is currently unavailable.';
    var view = drawer.querySelector('[data-sh-template-qa-view]');
    if (view) view.href = product.url + (variant && variant.id ? '?variant=' + encodeURIComponent(variant.id) : '');
  }

  function openDrawer(context, product, trigger) {
    createDrawer();
    active = { context: context, product: product };
    lastFocus = trigger || document.activeElement;
    seedSelection(product);
    renderDrawer();
    backdrop.classList.add('is-open');
    drawer.classList.add('is-open');
    backdrop.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sh-uc-lock');
    var close = drawer.querySelector('[data-sh-template-qa-close]');
    if (close) close.focus();
  }

  function closeDrawer(skipFocus) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    backdrop.classList.remove('is-open');
    drawer.classList.remove('is-open');
    backdrop.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sh-uc-lock');
    active = null;
    selectedOptions = [];
    var focus = lastFocus;
    lastFocus = null;
    if (skipFocus !== true && focus && typeof focus.focus === 'function') window.setTimeout(function () { focus.focus(); }, 30);
  }

  function onDrawerClick(event) {
    var close = event.target.closest('[data-sh-template-qa-close]');
    if (close) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var option = event.target.closest('[data-sh-uc-option-index], [data-sh-template-qa-option]');
    if (option) {
      event.preventDefault();
      var optionIndex = option.hasAttribute('data-sh-uc-option-index') ? Number(option.dataset.shUcOptionIndex) : Number(option.dataset.shTemplateQaOption);
      selectedOptions[optionIndex] = option.dataset.value;
      var adaptive = adaptiveQuickAdd();
      var matching = adaptive ? adaptive.findVariant(active.product, selectedOptions) : findVariant(active.product);
      if (!matching || !matching.available) {
        matching = adaptive ? adaptive.findCompatibleVariant(active.product, selectedOptions, optionIndex) : null;
      }
      if (matching) selectedOptions = matching.options.slice();
      renderDrawer();
      return;
    }

    var add = event.target.closest('[data-sh-template-qa-add]');
    if (add && active) {
      event.preventDefault();
      var variant = findVariant(active.product);
      if (variant && variant.available) addVariant(active.context.root, variant, add, true);
    }
  }

  function addVariant(root, variant, button, closeAfter) {
    if (!variant || !variant.id || !button || button.disabled) return;
    var original = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Adding…';
    var endpoint = (root && root.dataset.cartAddUrl) || (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';

    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variant.id), quantity: 1 })
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw new Error(payload && (payload.description || payload.message) || 'Unable to add this product.');
        return payload;
      });
    }).then(function (payload) {
      button.textContent = 'Added ✓';
      var cartOpener = lastFocus || button;
      if (closeAfter) closeDrawer(true);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: payload, addToCartBtn: cartOpener } }));
    }).catch(function (error) {
      console.error('SickHaus template quick add failed.', error);
      var status = drawer && drawer.querySelector('[data-sh-template-qa-status]');
      if (status) status.textContent = error.message || 'We could not add that option. Please try again.';
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = original;
    }).finally(function () {
      window.setTimeout(function () {
        if (!button.isConnected) return;
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = original;
      }, 1800);
    });
  }

  function directAdd(root, product, button) {
    var variant = product.variants.find(function (item) { return item.available; });
    if (!variant) return;
    addVariant(root, variant, button, false);
  }

  function onTemplateQuickClick(event) {
    var trigger = event.target.closest && event.target.closest('button[data-sh-quick],button[data-quick-add]');
    if (!trigger) return;
    if (trigger.closest('[data-sh-universal-grid]')) return;
    var context = findConfig(trigger);
    if (!context) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    context.triggerValue = trigger.dataset.shQuick || trigger.dataset.quickAdd || '';
    var product = getProduct(context);
    if (!product || !product.variants.length) return;
    var available = product.variants.filter(function (variant) { return variant.available; });
    if (available.length === 1) {
      directAdd(context.root, product, trigger);
      return;
    }
    openDrawer(context, product, trigger);
  }

  function onKeydown(event) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(drawer.querySelectorAll('button:not([disabled]),a[href]')).filter(function (node) {
      return node.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function adaptiveQuickAdd() {
    var cards = window.SickHausUniversalProductCards;
    var adaptive = cards && cards.adaptiveQuickAdd;
    return adaptive && typeof adaptive.renderOptions === 'function' ? adaptive : null;
  }

  function setText(selector, value) {
    var node = drawer && drawer.querySelector(selector);
    if (node) node.textContent = value || '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'\"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '\"': '&quot;' }[character];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  document.addEventListener('click', onTemplateQuickClick, true);
  document.addEventListener('keydown', onKeydown);
}());

